import { findPlantById } from './plantCatalogue';

/**
 * The saved collection, resolved against the catalogue (SPEC-014 D-1).
 *
 * What is stored is a list of ids, never plant records: a plant's prose, artwork
 * and scores are content that changes without a deploy (FR-07), so a garden that
 * kept copies would show whatever was true on the day it was saved.
 *
 * Most recently saved first (D-3). The stored list appends, so this reverses it —
 * a collection is not the catalogue, and the plant someone just saved is the one
 * they came back to look at.
 *
 * An id nothing answers to is dropped rather than drawn (D-2). Ids outlive
 * plants: packs are regenerated, ids are retired, and the stored list is the
 * user's to edit. The id itself stays in storage, so a catalogue that is briefly
 * missing a plant does not silently empty someone's garden.
 */
export function selectGardenPlants(plants, plantIds) {
    return [...plantIds]
        .reverse()
        .map((plantId) => findPlantById(plants, plantId))
        .filter(Boolean);
}
